module.exports = __webpack_public_path__ + "media/safaricom.c72ce20f.mp4";